import { KeyObjectBulkUpload } from "../../../../utils/enums/bulkUpload/key-object-bulkupload";

export const isValidKeyTemplate = (key: string) =>
    !key.includes(KeyObjectBulkUpload.firstName) &&
    !key.includes(KeyObjectBulkUpload.lastName) &&
    !key.includes(KeyObjectBulkUpload.email) &&
    !key.includes(KeyObjectBulkUpload.birthDate) &&
    !key.includes(KeyObjectBulkUpload.gender) &&
    !key.includes(KeyObjectBulkUpload.heightFT) &&
    !key.includes(KeyObjectBulkUpload.heightIN) &&
    !key.includes(KeyObjectBulkUpload.weight) &&
    !key.includes(KeyObjectBulkUpload.throwingArm) &&
    !key.includes(KeyObjectBulkUpload.bats) &&
    !key.includes(KeyObjectBulkUpload.PrimaryPosition) &&
    !key.includes(KeyObjectBulkUpload.SecondaryPosition) &&
    !key.includes(KeyObjectBulkUpload.playingLevel) &&
    !key.includes(KeyObjectBulkUpload.country) &&
    !key.includes(KeyObjectBulkUpload.stateOrProvidence);
